<template>
    <div class="product">
        <figure class="is-hidden-desktop product-image" @click="onProductSelected">
            <img v-if="product.thumbnail" :src="product.thumbnail | toCDNPath">
        </figure>

        <figure class="is-hidden-touch product-image">
            <img v-if="product.thumbnail" :src="product.thumbnail | toCDNPath">
            <div class="is-hidden-touch buttons has-addons product-actions">
                <a class="button is-large is-rounded" v-on:click="onAddToCartSelected">
                    <span class="icon"><i class="fal fa-cart-plus"></i></span>
                </a>
                <a class="button is-large is-rounded" v-on:click="onProductSelected">
                    <span class="icon"><i class="fal fa-search"></i></span>
                </a>
            </div>
        </figure>

        <div class="product-info">
            <h2 class="title">{{ product.name | capitalize }}</h2>
            <h2 class="subtitle">{{ product.presentation }}</h2>
            <span class="price">$ {{ product.price }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Product',
        props: ['product'],
        data() {
            return {}
        },
        methods: {
            onProductSelected(/*id*/) {
                this.$emit('product-selected', this.product);
            },

            onAddToCartSelected() {
                this.$store.dispatch('cart/add', { 
                    item: {
                        product: this.product.id,
                        quantity: 1
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .product {
        display: flex;
        flex-direction: column;
        text-align: left;

        -webkit-transition: all 10.3s ease 0.3s;
        -o-transition: all 0.3s ease 0.3s;
        transition: all 0.4s ease 0s;

        &:hover {
            /*box-shadow: 0 14px 28px rgba(0, 0, 0, 0.05), 0 10px 10px rgba(0, 0, 0, 0.02);*/

            .product-image {
                transition: all 0.4s ease 0s;
                transform: scale(1.15);

                cursor: pointer;

                .product-actions {
                    transition: all 0.4s ease 0s;
                    transform: translate(0px, 0px);
                    opacity: 1.0;
                }
            }
        }

        .product-image {
            position: relative;

            .product-actions {
                opacity: 0;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                width: fit-content;
                transform: translate(0px, -30px);
            }

            img {
                max-width: 100%;
            }
        }

        .product-info {
            margin-top: auto;

            .title {
                font-size: 0.9em;
                text-align: left;
            }

            .subtitle {
                font-size: 0.9em;
                margin-bottom: 0;
            }

            .price {
                color: #80b435;
            }
        }
    }
</style>